let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jKi31")).then(() => parcelRequire('5Mz5E'));